$(document).ready(function () {
    let base_url = $('meta[name=base-url]').attr('content');

    $("#ForgotPasswordBtn").on('click', (function (e) {
        e.preventDefault();
        grecaptcha.ready(function() {
            grecaptcha.execute(grck, {action: 'submit'}).then(function(token) {
                var frm = $('#commonForgotPasswordFrm');
                var btn = $('#ForgotPasswordBtn');
                let data = frm.serialize() + '&gtoken='+token
                if (frm.valid()) {
                    var showLoader = 'Processing...';
                    showButtonLoader(btn, showLoader, 'disabled');
                    $.ajax({
                        url: base_url + "/forgot-password",
                        type: "POST",
                        data: data,
                        success: function (response) {
                            showButtonLoader(btn, 'Sent', 'enable');
                            successToaster(response.message);
                            setTimeout(function(){
                                window.location.href = response.redirectionUrl;
                            },1000);
                        },
                        error: function (err) {
                            var obj = jQuery.parseJSON(err.responseText);
                            errorToaster(obj.message);
                            showButtonLoader(btn, 'Send', 'enable');
                        },
                    });
                }
            });
        });
    }));

})
